import { ReactNode } from 'react';

import { FlexAligner, LoadingBubbles, Tooltip, TypographyProps } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { Icon, responsive } from '@/utils';

import { ElementWrapper } from './ElementWrapper';

type DataRowValueProps = {
  isError?: boolean;
  isFetched?: boolean;
  isLoading?: boolean;
  type: TypographyProps['type'];
  value?: string | ReactNode;
};

export const DataRowValue = ({
  isError = false,
  isFetched = true,
  isLoading,
  type,
  value,
}: DataRowValueProps) => {
  const { t } = useTranslation(['orbitOne']);
  return (
    <FlexAligner gap={responsive.spacing.medium} fullWidth={false} alignment='bottom-left'>
      {isLoading && <LoadingBubbles />}
      {!isLoading && isFetched && value !== undefined && (
        <ElementWrapper value={value} type={type} />
      )}
      {!isLoading && isFetched && value === undefined && isError && (
        <Tooltip tooltip={t('orbitOne:biomass.errorFetchingData')}>
          <Icon.OctagonAlert size='medium' />
        </Tooltip>
      )}
      {!isLoading && isFetched && value === undefined && !isError && <Icon.Minus />}
    </FlexAligner>
  );
};
